<template>
    <div class="word-num">
        <v-row class="word-num__row">
            <v-col class="word-num__col">
                <v-card variant="outlined" class="word-num__col__card">
                    <v-card-title class="word-num__col__card__title">
                        Teacher Unique Word Counts
                    </v-card-title>
                    <v-card-text class="word-num__col__card__text">
                        {{ getUniqueWordCount(wordCount.teacher_word_count) }}
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="word-num__col">
                <v-card variant="outlined" class="word-num__col__card">
                    <v-card-title class="word-num__col__card__title">
                        Student Unique Word Counts
                    </v-card-title>
                    <v-card-text class="word-num__col__card__text">
                        {{ getUniqueWordCount(wordCount.student_word_count) }}
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { WordCount } from '@/models/models'

export default defineComponent({
    name: 'UniqueWordNumber',
    props: {
        wordCount: {
            type: Object as PropType<WordCount>,
            required: true,
        }
    },
    setup() {
        const getUniqueWordCount = (wordCount: object): number => {
            return Object.keys(wordCount).length;
        };

        return {
            getUniqueWordCount,
        }
    },
});
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';

.word-num {
    margin: 10px auto;
    &__row {
        margin: auto 10px;
    }
    &__col {
        &__card {
            &__title {
                font-weight: bold;
            }
            &__text {
                font-size: 24px;
            }
        }
    }
}
</style>
